<template>
  <v-dialog
    v-model="enableDialog"
    scrollable
    width="800"
    @click:outside="closeButtonClickEvent"
  >
    <v-card>
      <v-card-title>
        <v-chip
          small
          label
          dark
          :color="notification.notification_type | notification_type_chip_color"
        >
          <span class="v-size--small">{{ notification.notification_type | notification_type_to_label }}</span>
        </v-chip>
      </v-card-title>
      <v-card-subtitle class="mt-1">
        {{ notification.title }}
      </v-card-subtitle>
      <v-divider />
      <v-card-text style="height: 300px;">
        <div class="line-break">
          {{ notification.message }}
        </div>
      </v-card-text>
      <v-card-text class="text-right">
        {{ notification.notification_at }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
       notification: {
        // id: 1,
        // notification_type: 'jwnet_notification',
        // title: '処分終了報告(中間)通知を受け取りました。（マニフェスト番号：XXXXXXXXXXX）',
        // message: '処分終了報告(中間)通知を受け取りました。（マニフェスト番号：XXXXXXXXXXX）',
        // notification_at: "2022/01/06 11:36",
      },
    }
  },
  watch: {
    enableDialog (value) {
      if (value) {
        if (this.targetId) {
          this.searchShowNotification()
        }
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('AdminDxeNotification', {
      showNotification: 'show',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },

    /**
     * 詳細表示情報取得
     */
    searchShowNotification () {
      this.showNotification({ id: this.targetId }).then((content) => {
        this.notification = content
      })
    },
  }
}
</script>

<style scoped>
</style>
